import { FC, memo, useState } from 'react';
import TemplateCard from '../TemplateCard';
import TemplateCardActions from '../TemplateCardActions';
import { PolicyTemplate, PolicyTemplateStaticCategory } from '../../../../../types/policies';
import { LockedFeatureDisplayConfig } from '../../../../common/LockedFeatures';

interface Props {
    template: PolicyTemplate;
    handleStartFromTemplateClick: (template: PolicyTemplate) => void;
    addTemplateToFavorites: (template: PolicyTemplate) => void;
    removeTemplateFromFavorites: (template: PolicyTemplate) => void;
    handleMenuDeleteClick: (template: PolicyTemplate) => void;
    handleMenuEditClick: (template: PolicyTemplate) => void;
    handleMenuDuplicateClick: (template: PolicyTemplate) => void;
    startFromTemplateLockedFeatureConfig?: LockedFeatureDisplayConfig;
}

const TemplateListItem: FC<Props> = ({
    template,
    addTemplateToFavorites,
    removeTemplateFromFavorites,
    handleStartFromTemplateClick,
    handleMenuDuplicateClick,
    handleMenuEditClick,
    handleMenuDeleteClick,
    startFromTemplateLockedFeatureConfig
}) => {
    // Disclaimer:
    // Using state instead of tailwind to keep the card hovered while the tooltip (rendered outside) is active due to new pricing logic.
    const [isTemplateHovered, setIsTemplateHovered] = useState(false);
    return (
        <div
            key={template.id}
            className="relative h-[371px] group rounded-[24px] border border-sf-gray-100 overflow-hidden">
            <TemplateCard
                name={template.name}
                isFavorite={template.isFavorite}
                description={template.descriptionSummary}
                type={template.typeId}
                spns={template.spns}
                authTypes={template.authTypes}
                protocols={template.supportedProtocols}
                risks={template.risks}
            />
            <div
                className={`absolute inset-0 transition-opacity ease-in duration-[225ms] opacity-0 ${
                    isTemplateHovered ? 'opacity-100' : ''
                }`}
                onMouseEnter={() => setIsTemplateHovered(true)}
                onMouseLeave={() => setIsTemplateHovered(false)}>
                <TemplateCardActions
                    isFavorite={template.isFavorite}
                    showMenu={template.typeId === PolicyTemplateStaticCategory.CUSTOM}
                    onStartFromTemplateClick={() => handleStartFromTemplateClick(template)}
                    onAddToFavoritesClick={() => addTemplateToFavorites(template)}
                    onRemoveFromFavoritesClick={() => removeTemplateFromFavorites(template)}
                    onDeleteClick={() => handleMenuDeleteClick(template)}
                    onEditClick={() => handleMenuEditClick(template)}
                    onDuplicateClick={() => handleMenuDuplicateClick(template)}
                    startFromTemplateLockedFeatureConfig={startFromTemplateLockedFeatureConfig}
                />
            </div>
        </div>
    );
};

export default memo(TemplateListItem);
